import React from 'react';
import PublicLayout from './common/PublicLayout';
import SEO from '../components/common/SEO';
import FAQ, { questions } from '../components/FAQ';
import CTA from '../components/CTA';

/**
 * Recursively extracts text content from a JSX element.
 * @param {JSXElement} element
 * @returns {*}
 */
function extractTextFromJSX(element) {
  if (typeof element === 'string') {
    return element;
  }

  if (typeof element === 'number') {
    return String(element);
  }

  if (!element) {
    return '';
  }

  if (Array.isArray(element)) {
    return element.map(extractTextFromJSX).join(' ');
  }

  if (element.props && element.props.children) {
    return extractTextFromJSX(element.props.children);
  }

  return '';
}

export default function FAQPage() {
  const linkedData = {
    '@type': 'FAQPage',
    mainEntity: questions.map(item => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: extractTextFromJSX(item.response).trim()
      }
    }))
  };

  return (
    <PublicLayout className="my-2">
      <SEO
        title="Frequently Asked Questions | Meet List"
        description="Find answers to common questions about Meet List, the ultimate attendance solution for online meetings."
        linkedData={linkedData}
      />
      <FAQ />
      <CTA />
    </PublicLayout>
  );
}
